__turbopack_context__.v({
  "className": "fontseasonsans_a806b64d-module__xI3eEa__className",
  "variable": "fontseasonsans_a806b64d-module__xI3eEa__variable",
});
